export * from './empresa/empresa.service';
export * from './oficina/oficina.service';
export * from './usuario/usuario.service';
export * from './alert/alert.service';
export * from './cuentas/cuentas.service';
export * from './socios/socios.service';
export * from './caja/transferencias.service';
export * from './mensajes/sgf-mensajes.service';
export * from './spi/spi.service';
export * from './pais/pais.service';
export * from './provincia/provincia.service';
export * from './canton/canton.service';
export * from './parroquia/parroquia.service';
export * from './barrio/barrio.service';
export * from './det-mov-dia/sgf_det_mov_dia.service';
export * from './producto/sgf-producto.service';
export * from './creditos/sgf-credito.service';
export * from './descuentos/descuento.service';